import React, { useState } from "react"
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../PermissionsConstants";
import { ScoreCardTable } from "./view/ScoreCardTable";

interface Props { }

export const ScoreCard: React.FC<Props> = () => {
  const viewPermission =
    PERMISSIONS.permission_scorecard_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>{userPermissions.includes(viewPermission) ? <ScoreCardTable /> : ""}</>
  );
}